module.exports = __webpack_public_path__ + "static/media/team2.7d504416.jpg";